module.exports = __webpack_public_path__ + "static/media/gps.b9a78ae7.svg";